import type {ReactNode} from 'react'
import {cn} from '@/lib/utils'

type DiffStyle = 'new' | 'changed' | 'unchanged'
type DiffRowLayout = 'row' | 'column'

interface DiffRowProps {
    children: ReactNode
    /** Diff highlight color — left border in success/warning/none. */
    diffStyle: DiffStyle
    /** `row` (default) puts children on a baseline-aligned flex row; `column` stacks them. */
    layout?: DiffRowLayout
    'data-testid'?: string
}

/* eslint-disable i18next/no-literal-string -- CSS class constants */
const diffClasses: Record<DiffStyle, string> = {
    new: 'border-l-4 border-l-green-500 pl-3',
    changed: 'border-l-4 border-l-amber-500 pl-3',
    unchanged: '',
}
const layoutClasses: Record<DiffRowLayout, string> = {
    row: 'flex items-baseline gap-2',
    column: '',
}
/* eslint-enable i18next/no-literal-string */

/**
 * A single row of a before/after review list. Pair inside a `<dl>` or `DetailList`
 * to show added/changed/unchanged values with a colored left-border marker.
 */
export function DiffRow({children, diffStyle, layout = 'row', 'data-testid': testId}: DiffRowProps) {
    return (
        <div
            className={cn(layoutClasses[layout], 'py-1', diffClasses[diffStyle])}
            data-testid={testId}
        >
            {children}
        </div>
    )
}
